import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/promotions`, payload);
};

const find = (merchantId, promotionCode, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/promotions/${promotionCode}`,
		payload
	);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/promotions`, payload);
};

const update = (merchantId, promotionCode, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/promotions/${promotionCode}`,
		payload
	);
};

const remove = (merchantId, promotionCode, payload) => {
	return Client.del(
		`${baseUrl}/${merchantId}/promotions/${promotionCode}`,
		payload
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
